import { FC } from 'react';

import leapifyLogo from 'assets/images/Leapify-Logo.svg';
import { type FormikHelpers } from 'formik';
import { Formik } from 'formik';
import { TermsPolicy } from 'pages/public/components/common';
import AdminLoginForm from 'pages/public/forms/AdminLoginForm';
import { LOGIN_FORM, LOGIN_SCHEMA } from 'pages/public/forms/schema';
import { useAdminLogin } from 'pages/public/hooks';
import { cn } from 'utils/helpers';

import PublicWrapper from '../PublicWrapper';

const FORM_INIT = {
  emailAddress: '',
  password: '',
  remember: false,
} as LOGIN_FORM;

interface PROPS {
  isLoading: boolean;
  onSubmit: (values: LOGIN_FORM, helpers: FormikHelpers<LOGIN_FORM>) => void;
}

const AdminLogin: FC<PROPS> = ({ onSubmit, isLoading }) => {
  return (
    <Formik
      initialValues={FORM_INIT}
      onSubmit={onSubmit}
      validationSchema={LOGIN_SCHEMA}
    >
      {({ isSubmitting }) => (
        <>
          <img
            alt="Leapify Logo"
            className="w-[170px] mb-[55px] inline-block mx-auto"
            src={leapifyLogo}
          />
          <div data-aos="fade-up" className="text-center space-y-4">
            <div
              className={cn(
                'rounded-[6px] bg-fill-tertiary',
                'px-[31px] py-[56px]',
                'md:w-[490px]',
                'sm:w-full',
              )}
            >
              <h3 className="mb-[30px] text-center text-xl font-semibold">
                Welcome to Admin portal
              </h3>
              <AdminLoginForm isLoading={isLoading || isSubmitting} />
            </div>
            <div className="text-content text-xs">
              v{import.meta.env.VITE_APP_VERSION}
            </div>
          </div>
        </>
      )}
    </Formik>
  );
};

const AdminLoginWrapper: FC = () => {
  const { mutate: login, isLoading } = useAdminLogin();

  const onSubmit = (
    value: LOGIN_FORM,
    { setSubmitting }: FormikHelpers<LOGIN_FORM>,
  ) => {
    login(value);
    setSubmitting(false);
  };

  return (
    <>
      {/* <Head title="Login" /> */}
      <PublicWrapper
        className={cn(
          'h-full relative bg-disabled',
          'flex flex-col items-center',
          'text-sm text-secondary-base',
        )}
      >
        <div className="flex-1 flex flex-col justify-center items-center w-full">
          <AdminLogin onSubmit={onSubmit} isLoading={isLoading} />
        </div>
        <TermsPolicy />
      </PublicWrapper>
    </>
  );
};

export default AdminLoginWrapper;
